export default "/images/bluetooth.svg?4e0cbf9069a8de16e558d73d3c37d779";